import React from 'react' // eslint-disable-line no-unused-vars
import { RingLoader } from 'react-spinners'

export const SubmitInquiryLoading = props => {
  const { languageContent, flowType } = props
  return (
    <div className='widget-mb-0-row'>
      <div className='row'>
        <div className='col-12 col-xl-12'>
          <h3 className='mb-3 header-primary'>{languageContent.module.submitInquiry.title}</h3>
          {flowType === 'MI_PORTAL_REQUEST'
            ? <p>{languageContent.module.submitInquiry.subTitle}</p>
            : ''}
        </div>
      </div>

      <div className='row'>
        <div className='col-12 col-xl-12'>
          <h6 className='mb-2'>
            {languageContent.module.submitInquiry.loading}
          </h6>
        </div>
      </div>
      <div>
        <RingLoader
          color='#071d49'
          loading
        />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/SubmitInquiryLoading.js